import React from "react";
import { HiOutlinePencilAlt, HiOutlineRefresh } from "react-icons/hi";

const SignatureStatusPanel = ({
  hasSignature,
  signed,
  onOpenSignature,
  onClearSignature,
}) => (
  <div className="mb-4 rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-800 dark:border-blue-900/60 dark:bg-blue-950/40 dark:text-blue-200">
    <div className="flex items-center justify-between gap-3">
      <span className="font-semibold">
        {hasSignature || signed
          ? "Signature added"
          : "Tap the blue Customer box to sign"}
      </span>
      {!signed && (
        <div className="flex shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={onOpenSignature}
            className="inline-flex items-center gap-1.5 rounded-md border border-blue-200 bg-white px-2.5 py-1.5 text-xs font-semibold text-blue-700 transition hover:border-blue-400 dark:border-blue-800 dark:bg-gray-900 dark:text-blue-200"
          >
            <HiOutlinePencilAlt className="h-4 w-4" />
            Sign
          </button>
          <button
            type="button"
            onClick={onClearSignature}
            className="inline-flex items-center gap-1.5 rounded-md border border-blue-200 bg-white px-2.5 py-1.5 text-xs font-semibold text-blue-700 transition hover:border-blue-400 dark:border-blue-800 dark:bg-gray-900 dark:text-blue-200"
          >
            <HiOutlineRefresh className="h-4 w-4" />
            Clear
          </button>
        </div>
      )}
    </div>
  </div>
);

export default SignatureStatusPanel;
